import { Flex } from "antd";
import SupportTable from "./SupportTable";
import SupportForm from "../../forms/SuportForm";

export default function Support() {
  return (
    <>
      <Flex gap="large" wrap="wrap">
        <SupportForm />
      </Flex>
      <SupportTable />
    </>
  );
}
